var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1297 4.79487C14.358 4.56762 14.7276 4.56849 14.9549 4.79683C15.1821 5.02518 15.1813 5.39476 14.9529 5.62202L7.3328 13.205C7.10526 13.4313 6.73807 13.4313 6.51054 13.205L3.04667 9.75776C2.81853 9.53055 2.81768 9.16186 3.04472 8.93354C3.27198 8.70519 3.64156 8.70433 3.86991 8.93159L6.92167 11.9687L14.1297 4.79487Z",
    fill: "#33995E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.aba10309165b4e3935b56cc07593dbd5.svg";
export { ForwardRef as ReactComponent };